<script setup lang="ts">
import { useRedirect } from "@core/composables"
import { useI18n } from "vue-i18n"
import { formatIdSource } from "@core/helpers"
import { BuildingSource } from "@types"

const { t } = useI18n({
    messages: {
        fr: {
            title: "Liste des sources",
            question: "À quelle source souhaitez-vous accéder ?",
        },
    },
})

type Props = {
    sources: Partial<BuildingSource>[]
}

withDefaults(defineProps<Props>(), {
    sources: () => [],
})

defineEmits(["click:source"])

const [visible] = defineModel<boolean>("visible", {
    required: true,
    default: false,
})

const { redirectWrapper } = useRedirect()

/**
 * Gère l'action à effectuer lors du clic sur une source.
 */
function onClickSource(source: Props["sources"][0]) {
    redirectWrapper("/source/:_id_source/data", {
        _id_source: source._id,
    })
}
</script>

<template>
    <BaseDialog
        v-model:visible="visible"
        modal
        :closable="true"
        dismissable-mask
        class="modal-source-list max-w-[25rem] w-full"
    >
        <template #header>
            <h2 class="text-lg text-primary font-semibold">
                {{ t("title") }}
            </h2>
        </template>
        <p class="modal-source-list__title text-primary py-4">
            {{ t("question") }}
        </p>
        <div
            class="modal-source-list__content flex flex-col gap-2 max-h-[22.5rem] overflow-y-auto"
        >
            <BaseButton
                v-for="(source, index) in sources"
                :key="index"
                outlined
                class="modal-source-list__content-element justify-start gap-2 min-h-[4.5rem] max-h-[4.5rem]"
                @click="onClickSource(source)"
            >
                <BaseSourceIcon :type="source.idtype!" />
                <p
                    class="text-primary text-sm text-left modal-source-list__source-name flex flex-col"
                >
                    <span v-if="source.name">{{ source.name }}</span>
                    <span>{{
                        formatIdSource(source.idsource!, source.idtype!)
                    }}</span>
                </p>
            </BaseButton>
        </div>
    </BaseDialog>
</template>
